import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment-timezone";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import TruncatedTd from "../layout/TruncatedTd";
import OrderStatusBadge from "./OrderStatusBadge";
import Pagination from "../layout/Pagination";
import Actions from "./Actions";
import PermissionGate from "../layout/PermissionGate";
import socket from "../socket/socket";

const AllOrders = () => {
  const [data, setData] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [branches, setBranches] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [merchant, setMerchant] = useState({});
  const [branch, setBranch] = useState({});
  const [driver, setDriver] = useState({});
  const [orderChannel, setOrderChannel] = useState({});
  const [orderId, setOrderId] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [branchName, setBranchName] = useState("");
  const [driverNameOrPhone, setDriverNameOrPhone] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const dateRangePickerRef = useRef(null);
  const token = localStorage.getItem("token");
  const limit = process.env.REACT_APP_PAGINATION_LIMIT;

  const fetchOrders = () => {
    axios
      .get(
        `${
          process.env.REACT_APP_API_ENDPOINT
        }order/get?page=${page}&limit=${limit}&orderId=${orderId}&merchantId=${
          merchant.value === undefined ? "" : merchant.value
        }&branchId=${branch.value === undefined ? "" : branch.value}&driverId=${
          driver.value === undefined ? "" : driver.value
        }&orderChannel=${
          orderChannel.value === undefined ? "" : orderChannel.value
        }&customerPhone=${customerPhone}&branchName=${branchName}&driver=${driverNameOrPhone}&startDate=${start}&endDate=${end}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          if (page > 1) {
            if (res.data.data.length === 0) {
              setPage(page - 1);
            } else {
              setData(res.data.data);
              setCount(res.data.count);
              setIsLoading(false);
            }
          } else {
            setData(res.data.data);
            setCount(res.data.count);
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const fetchMerchantList = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}merchant-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setMerchants(res.data.data);
        }
      })
      .catch(console.error);
  };
  const fetchBranchList = (merchantId) => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}branch-list/${merchantId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setBranches(res.data.data);
        }
      })
      .catch(console.error);
  };
  const fetchDriverList = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}driver-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setDrivers(res.data.data);
        }
      })
      .catch(console.error);
  };
  const reset = () => {
    setPage(1);
    setOrderId("");
    setMerchant({});
    setBranch({});
    setBranches([]);
    setDriver({});
    setOrderChannel({});
    setCustomerPhone("");
    setBranchName("");
    setDriverNameOrPhone("");
    setStart("");
    setEnd("");
  };
  const openCalendar = () => {
    if (dateRangePickerRef.current) {
      dateRangePickerRef.current.flatpickr.open();
    }
  };
  useEffect(() => {
    fetchMerchantList();
    fetchDriverList();
  }, []);
  useEffect(() => {
    fetchOrders();
  }, [
    page,
    orderId,
    merchant,
    branch,
    driver,
    orderChannel,
    customerPhone,
    branchName,
    driverNameOrPhone,
    start,
    end,
  ]);

  useEffect(() => {
    socket.on(`admin:ordersUpdate`, (data) => {
      if (!data?.orderId?.trim()) return;
      fetchOrders();
    });
    return () => {
      socket.off(`admin:ordersUpdate`);
    };
  }, []);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className="container-xxl d-flex justify-content-between"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Order List
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
                {/*begin::Button*/}
                <PermissionGate required={`view_order_list`} fallback={<></>}>
                  <button
                    onClick={reset}
                    className="btn btn-color-danger bg-body mx-3"
                  >
                    Reset
                  </button>
                </PermissionGate>
                {/*end::Button*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}
            <div>
              {/*begin::Container*/}
              <div className="container-xxl">
                {/*begin::Actions*/}
                <PermissionGate required={`view_order_list`} fallback={<></>}>
                  <div className="row">
                    <div className="col-sm-12 col-md mb-3">
                      {/* begin::Merchant List */}
                      <Select
                        className="react-select-styled react-select-bordered"
                        styles={{ width: "100%" }}
                        classNamePrefix="react-select"
                        value={merchant.value === undefined ? null : merchant}
                        onChange={(e) => {
                          setMerchant(e);
                          fetchBranchList(e?.value);
                        }}
                        options={merchants?.map((item) => {
                          return {
                            value: item?._id,
                            label: item?.merchantName,
                          };
                        })}
                        placeholder="Search Merchant"
                      />
                      {/* end::Merchant List */}
                    </div>
                    <div className="col-sm-12 col-md mb-3">
                      {/* begin::Branch List */}
                      <Select
                        className="react-select-styled react-select-bordered"
                        classNamePrefix="react-select"
                        value={branch.value === undefined ? null : branch}
                        onChange={(e) => {
                          setBranch(e);
                        }}
                        options={branches?.map((item) => {
                          return {
                            value: item?._id,
                            label: item?.name,
                          };
                        })}
                        placeholder="Search Branch"
                      />
                      {/* end::Branch List */}
                    </div>
                    <div className="col-sm-12 col-md mb-3">
                      {/* begin::Driver List */}
                      <Select
                        className="react-select-styled react-select-bordered"
                        classNamePrefix="react-select"
                        value={driver.value === undefined ? null : driver}
                        onChange={(e) => {
                          setDriver(e);
                        }}
                        options={drivers?.map((item) => {
                          return {
                            value: item?._id,
                            label: item?.name,
                          };
                        })}
                        placeholder="Search Driver"
                      />
                      {/* end::Driver List */}
                    </div>
                    <div className="col-sm-12 col-md mb-3">
                      {/* begin::Order Channel List */}
                      <Select
                        className="react-select-styled react-select-bordered"
                        classNamePrefix="react-select"
                        value={
                          orderChannel.value === undefined ? null : orderChannel
                        }
                        onChange={(e) => {
                          setOrderChannel(e);
                        }}
                        options={[
                          {
                            value: "Merchant UI",
                            label: "Merchant UI",
                          },
                          {
                            value: "Chrome Extenstion",
                            label: "Chrome Extenstion",
                          },
                          {
                            value: "Captain App",
                            label: "Captain App",
                          },
                          {
                            value: "API",
                            label: "API",
                          },
                        ]}
                        placeholder="Order Channel"
                      />
                      {/* end::Order Channel List */}
                    </div>
                    <div className="col-sm-12 col-md mb-3">
                      {/*begin::Daterange*/}
                      <div className="d-flex position-relative">
                        <Flatpickr
                          ref={dateRangePickerRef}
                          value={
                            start !== "" && end !== ""
                              ? [new Date(start), new Date(end)]
                              : null
                          }
                          options={{ dateFormat: "d-m-Y", mode: "range" }}
                          onChange={([start, end]) => {
                            if (
                              start !== undefined &&
                              end !== undefined &&
                              typeof start === "object" &&
                              typeof end === "object"
                            ) {
                              setStart(moment(start).format("YYYY-MM-DD"));
                              setEnd(moment(end).format("YYYY-MM-DD"));
                            }
                          }}
                          className="form-control form-control-lg"
                          placeholder="Order date"
                        />
                        <i
                          onClick={openCalendar}
                          className="bi-duotone bi-calendar fs-5 position-absolute"
                          style={{ top: "28%", right: "5%", cursor: "pointer" }}
                        ></i>
                      </div>
                      {/*end::Daterange*/}
                    </div>
                  </div>
                </PermissionGate>
                {/*end::Actions*/}
              </div>
              {/*end::Container*/}
            </div>

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start container-xxl"
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                {/*begin::Card*/}
                <PermissionGate required={`view_order_list`}>
                  <div className="card">
                    {/*begin::Card header*/}
                    <div className="card-header border-0 pt-6">
                      {/*begin::Card title*/}
                      <div className="w-100">
                        <div className="row">
                          <div className="col-md-3">
                            {/*begin::Order Id Search*/}
                            <div className="my-1">
                              <input
                                type="text"
                                value={orderId}
                                autoComplete="off"
                                onChange={(e) => {
                                  setOrderId(e.target.value);
                                }}
                                className="form-control"
                                placeholder="Search by Order Id"
                              />
                            </div>
                            {/*end::Order Id Search*/}
                          </div>
                          <div className="col-md-3">
                            {/*begin::Customer Phone Search*/}
                            <div className="my-1">
                              <input
                                type="text"
                                value={customerPhone}
                                autoComplete="off"
                                onChange={(e) => {
                                  setCustomerPhone(e.target.value);
                                }}
                                className="form-control"
                                placeholder="Customer Phone No"
                              />
                            </div>
                            {/*end::Customer Phone Search*/}
                          </div>
                          <div className="col-md-3">
                            {/*begin::Branch Name Search*/}
                            <div className="my-1">
                              <input
                                type="text"
                                value={branchName}
                                autoComplete="off"
                                onChange={(e) => {
                                  setBranchName(e.target.value);
                                }}
                                className="form-control"
                                placeholder="Branch Name"
                              />
                            </div>
                            {/*end::Branch Name Search*/}
                          </div>
                          <div className="col-md-3">
                            {/*begin::Driver Search*/}
                            <div className="my-1">
                              <input
                                type="text"
                                value={driverNameOrPhone}
                                autoComplete="off"
                                onChange={(e) => {
                                  setDriverNameOrPhone(e.target.value);
                                }}
                                className="form-control"
                                placeholder="Driver Name, Phone No"
                              />
                            </div>
                            {/*end::Driver Search*/}
                          </div>
                        </div>
                      </div>
                      {/*begin::Card title*/}
                    </div>
                    {/*end::Card header*/}

                    {/*begin::Card body*/}
                    <div
                      className="card-body py-4 text-center"
                      id="filterDataWrap"
                    >
                      {data?.length === 0 ? (
                        <div className="text-center w-100">
                          <img
                            className="w-25 mx-auto py-20"
                            src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                            alt="no-content"
                          />
                        </div>
                      ) : (
                        <div className="table-responsive">
                          {/*begin::Table*/}
                          <table className="table align-middle table-row-dashed fs-6 gy-5">
                            <thead>
                              <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                                <th className="text-center min-w-100px">
                                  Order Id
                                </th>
                                <th className="text-center min-w-100px">
                                  Merchant
                                </th>
                                <th className="text-center min-w-100px">
                                  Branch
                                </th>
                                <th className="text-center min-w-100px">
                                  Area
                                </th>
                                <th className="text-center min-w-100px">
                                  Customer Name
                                </th>
                                <th className="text-center min-w-100px">
                                  Driver
                                </th>
                                <th className="text-center min-w-100px">
                                  Driver Phone
                                </th>
                                <th className="text-center min-w-100px">
                                  Status
                                </th>
                                <th className="text-center min-w-100px">
                                  Order Time
                                </th>
                                <th className="text-center min-w-100px">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold">
                              {data &&
                                data?.map((item, index) => {
                                  return (
                                    <tr className="text-center" key={index}>
                                      <td>
                                        <Link
                                          to={`/orders/order-details/${item?._id}`}
                                        >
                                          {item?.orderId}
                                        </Link>
                                      </td>
                                      <TruncatedTd length={8}>
                                        {item?.merchantName}
                                      </TruncatedTd>
                                      <TruncatedTd length={8}>
                                        {item?.branchName}
                                      </TruncatedTd>
                                      <TruncatedTd length={8}>
                                        {item?.area?.value}
                                      </TruncatedTd>
                                      <TruncatedTd length={8}>
                                        {item?.customerName}
                                      </TruncatedTd>
                                      <TruncatedTd length={8}>
                                        {item?.driverName ?? "---"}
                                      </TruncatedTd>
                                      <TruncatedTd length={8}>
                                        {item?.driverPhone ?? "---"}
                                      </TruncatedTd>
                                      <td>
                                        <OrderStatusBadge
                                          status={item?.status}
                                        />
                                      </td>
                                      <td>
                                        {moment(item?.orderDateTime)
                                          .tz(process.env.REACT_APP_TIMEZONE)
                                          .format("HH:mm, Do MMM, YYYY")}
                                      </td>
                                      <td className="">
                                        <Actions
                                          id={item?._id}
                                          status={item?.status}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                          {/*end::Table*/}
                        </div>
                      )}
                      {/*begin::Paginate*/}
                      {count && Math.ceil(count / limit) > 1 ? (
                        <Pagination
                          page={page}
                          setPage={setPage}
                          count={count}
                          limit={limit}
                        />
                      ) : (
                        ""
                      )}
                      {/*end::Paginate*/}
                    </div>
                    {/*end::Card body*/}
                  </div>
                </PermissionGate>
                {/*end::Card*/}
              </div>
              {/*end::Post*/}
            </div>
          </div>
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default AllOrders;
